import React, { Component } from "react"

import "./comparison-slider.css"

class ComparisonSlider extends Component {

    constructor(props){
        super(props);
        this.state = {
            sliderValue : 30
        }
    }


    render() {
      return (
                <div id="slider-section-container" className="-mt-4 container flex flex-col sm:flex-row sm:items-center">
                    <div id="slider-comparison-container" className="rounded-b-md sm:rounded-md sm:shadow-lg sm:-ml-4 sm:w-3/5">
                        <div className="bg-compare font-bold px-10 py-6 rounded-t-md uppercase">Compare transaction costs</div>
                        <div className="bg-white p-6 text-sm sm:pb-10 sm:pt-8 sm:px-10 sm:rounded-t-md rounded-b-md">
                            <div className="slidecontainer py-3">
                                <span className='range-slider'>
                                    <input className="slider" for="" value={this.state.sliderValue} onChange={(event) => this.setState({sliderValue: event.target.value})} min="1" max="250" name="rangeslider" id="comparison-range-slider" type="range" />
                                    <span className='slider-container'><span className='bar'><span></span></span><span className='bar-btn text-blue-darker' style={{left: this.state.sliderValue/2.5 + '%' }}><label for="comparison-range-slider">{"S$" + this.state.sliderValue}</label></span></span>
                                </span>
                            </div>
                            <table className="w-full text-blue-darker text-sm">
                                <tbody>
                                    <tr className="border-gray-dark  sm:border-0 ">
                                        <td className="pr-5 pl-2 py-3 sm:pl-0 border-r"></td>
                                        <td className="px-3 py-3 border-r"><span className="font-bold uppercase">Credit Cards</span></td>
                                        <td className="px-3 pr-6 py-3 sm:pr-0"><span className="font-bold uppercase">Maesh</span></td>
                                    </tr>
                                    <tr className="border-gray-dark ">
                                        <td className="pr-2 pl-2 py-3 sm:pl-0 border-r">Percentage</td>
                                        <td className="px-3 py-3 border-r"><span id="stripe-percentage">3.4</span>%</td>
                                        <td className="px-3 pr-6 py-3 sm:pr-0"><span id="maesh-percentage">0.7</span>%</td>
                                    </tr>
                                    <tr className="border-gray-dark ">
                                        <td className="pr-5 pl-2 py-3 sm:pl-0 border-r">Fixed</td>
                                        <td className="px-3 py-3 border-r">S$<span id="stripe-fixed">0.50</span></td>
                                        <td className="px-3 pr-6 py-3 sm:pr-0">S$<span id="maesh-fixed">0.25</span></td>
                                    </tr>
                                    <tr className="border-gray-dark ">
                                        <td className="pr-5 pl-2 py-3 sm:pl-0 border-r"><strong>Total cost</strong> </td>
                                        <td className="px-3 py-3 border-r">
                                            <div className="bg-gray-darkest font-bold px-2 py-1 rounded-sm"><span
                                                    id="stripe-cost">{"S$" + (this.state.sliderValue * 0.034 + 0.5).toFixed(2)}</span></div>
                                        </td>
                                        <td className="px-3 pr-6 py-3 sm:pr-0">
                                            <div className="bg-gray-darkest font-bold px-2 py-1 rounded-sm"><span
                                                    id="maesh-cost"> {"S$" + (this.state.sliderValue * 0.007 + 0.25).toFixed(2)}</span></div>
                                        </td>
                                    </tr>
                                    <tr className="border-gray-dark ">
                                        <td className="pr-5 pl-2 py-1 sm:pl-0"></td>
                                        <td className="px-1 py-1 text-right">Fees saved</td>
                                        <td className="px-3 pr-6 py-1 sm:pr-0">
                                            <div className="font-bold px-2 py-1 rounded-sm">S$<span id="cost-saved">{((this.state.sliderValue * 0.034 + 0.5) - (this.state.sliderValue * 0.007 + 0.25)).toFixed(2)}</span></div>
                                        </td>
                                    </tr>
                                    <tr className="border-gray-dark ">
                                        <td className="pr-5 pl-2 py-1 sm:pl-0"></td>
                                        <td className="px-1 py-1 text-right">In percentage</td>
                                        <td className="px-3 pr-6 py-1 sm:pr-0">
                                            <div className="bg-green font-bold px-2 py-1 rounded-sm"><span id="margin">{((1 - ((this.state.sliderValue * 0.007 + 0.25) / (this.state.sliderValue * 0.034 + 0.5)))*100).toFixed(0) + "%"}</span></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
          )
        }
    }

export default ComparisonSlider;
